import gql from 'graphql-tag'

export const PairingsListQuery = gql`
  query Pairings($triageStatus: PairingTriageStatus) {
    pairings(triageStatus: $triageStatus) {
      id
      triageStatus
      basis
      score
      triagedBy {
        name
      }
      leadId
      lead {
        id
        projectName
        developerName
        wgnetClientName
        address
        units
        multiplicity {
          candidateCount
          pairCount
        }
      }
      wgnetProject
    }
  }
`

export const TriagePairingMutation = gql`
  mutation TriagePairing($triageList: [PairingTriageInput]!) {
    triagePairings(triageList: $triageList) {
      id
      triageStatus
    }
  }
`
